<template>
  <a-layout class="s_bf">
    <a-form ref='ruleForm' :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="参与范围" name='range_type' class="m-t-20" required>
        <a-radio-group v-model:value="form.range_type" @change="form.range_data = [];" :disabled="$route.query.type=='edit'">
          <a-radio :value="2">门店</a-radio>
          <a-radio :value="1">经销商</a-radio>
        </a-radio-group>
        <div class="m-t-20 s_flex_bian">
          <a-button v-if="form.range_type==1" type="primary" @click="changedealer">选择经销商</a-button>
          <a-button v-if="form.range_type==2" type="primary" @click="showStore=true">选择门店</a-button>
          <div style="width:350px" class="s_flex_bian" v-if="form.range_type==1">
            <a-input v-model:value="BatchSetdelar" style="width:250px" placeholder="请输入签约任务量" />
            <a-button type="primary" @click="BatchSettingsdelar">批量设置</a-button>
          </div>
          <div style="width:350px" class="s_flex_bian" v-if="form.range_type==2">
            <a-input v-model:value="BatchSetstore" style="width:250px" placeholder="请输入签约任务量" />
            <a-button type="primary" @click="BatchSettingsstore">批量设置</a-button>
          </div>
        </div>

        <div class="m-t-20">
          <a-table :scroll="{ x: 500, y: 500 }" v-if="form.range_type==2" :pagination='false' bordered rowKey='id' :columns='storecolumns' :data-source='storedata'>
            <template v-slot:task_number="{ record }">
              <a-input-number v-model:value="record.task_number" :min="0" />
            </template>
            <template v-slot:action="{ index }">
              <a-button type="link" size="small" @click="delstore(index)">删除</a-button>
            </template>
          </a-table>
          <a-table :scroll="{ x: 500, y: 500 }" v-if="form.range_type==1" :pagination='false' bordered rowKey='id' :columns='delarcolumns' :data-source='delardata'>
            <template v-slot:task_number="{ record }">
              <a-input-number v-model:value="record.task_number" :min="0" />
            </template>
            <template v-slot:action="{ index }">
              <a-button type="link" size="small" @click="deldelar(index)">删除</a-button>
            </template>
          </a-table>
        </div>
      </a-form-item>
      <a-form-item label="状态" name='status' class="m-t-20">
        <a-radio-group v-model:value="form.status">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>

  </a-layout>
  <div class="s_flex_center">
    <a-button @click="provide()" class="  m-t-20 m-r-20">上一步</a-button>
    <a-button type="primary" @click="next()" class="  m-t-20 ">保存</a-button>
    <!-- <a-button type="primary" @click="next()" class="  m-t-20 ">下一步</a-button> -->
  </div>
  <a-modal title="选择经销商" v-model:visible="visible" centered :width='1200' destroyOnClose :footer="null">
    <selectDealer :selectList='delardata' :isSubDealer="true" v-on:select="dealerSelect" :mustShowHeadquarters='false' :checkout='true'></selectDealer>
  </a-modal>
  <a-modal :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1200' destroyOnClose :footer="null">
    <selectStore :checkout='true' v-on:select="storeSelect" :selectList='storedata' :hiddenHead='true'></selectStore>
  </a-modal>
</template>
<script>
import {
  detailcontracting,
  twocontracting,
  detailcontractingtask,
} from "@/api/guide";
import {} from "@ant-design/icons-vue";
import { inject, onMounted, reactive, ref, toRefs } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
const formData = {
  range_type: 2,
  status: 1,
  range_data: [],
};
export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },

  setup(props, { emit }) {
    let storedata = ref([]);
    let delardata = ref([]);
    const ruleForm = ref();
    const form = ref({ ...formData });
    const state = reactive({
      visible: false,
      showStore: false,
      BatchSetdelar: "",
      BatchSetstore: "",
      rang_type: "", //参与范围
      rules: {
        range_type: [
          {
            required: true,
            message: "请选择范围",
          },
        ],
      },
      storecolumns: [
        {
          title: "门店编号",
          dataIndex: "store_code",
          key: "store_code",
        },
        {
          title: "门店名称",
          dataIndex: "store_name",
          key: "store_name",
        },
        {
          title: "门店类型",
          key: "type_name",
          dataIndex: "type_name",
        },
        {
          title: "联系人",
          dataIndex: "clerk_name",
          key: "clerk_name",
        },
        {
          title: "手机号码",
          dataIndex: "clerk_phone",
          key: "clerk_phone",
          customRender: ({ record }) => {
            return record.clerk_phone ? record.clerk_phone : "-";
          },
        },
        {
          title: "签约任务量",
          dataIndex: "task_number",
          key: "task_number",
          slots: { customRender: "task_number" },
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          slots: { customRender: "action" },
        },
      ],
      delarcolumns: [
        {
          title: "经销商编号",
          dataIndex: "dealer_sn",
          key: "dealer_sn",
        },
        {
          title: "经销商名称",
          dataIndex: "dealer_name",
          key: "dealer_name",
        },
        {
          title: "经销商级别",
          key: "level_name",
          dataIndex: "level_name",
        },
        {
          title: "联系人",
          dataIndex: "leader_name",
          key: "leader_name",
        },
        {
          title: "手机号码",
          dataIndex: "leader_phone",
          key: "leader_phone",
        },
        {
          title: "签约任务量",
          dataIndex: "task_number",
          key: "task_number",
          slots: { customRender: "task_number" },
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          slots: { customRender: "action" },
        },
      ],
    });
    const $route = inject("$route");
    // 获取参与范围
    const dSearch = ref({
      page: 1,
      limit: 2,
      total: 0,
    });
    var getRanges = async () => {
      let Result = await detailcontractingtask({
        id: $route.query.id,
        ...dSearch.value,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (state.rang_type == 1) {
        delardata.value = Result.data.data;
      } else {
        storedata.value = Result.data.data;
      }
      console.log(delardata.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      dSearch.value.page = page;
      getRanges();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      dSearch.value.page = 1;
      dSearch.value.limit = limit;
      getRanges();
    };
    // const listLoading = ref(true);
    const list = ref([]);
    // 获取详情
    const detail = async () => {
      let result = await detailcontracting({ id: props.id })
        .then((res) => res.data)
        .catch((error) => error);
      console.log(result);
      if (iscode(result)) {
        form.value = result.data;
        state.rang_type = result.data.range_type;
        getRanges();
      } else {
        message.error(result.message);
      }
    };
    //经销商选择
    const dealerSelect = (data) => {
      console.log(data);
      delardata.value = data;
      state.visible = false;
    };
    const changedealer = () => {
      state.visible = true;
    };
    //选择门店
    const storeSelect = (data) => {
      console.log(data);
      data.forEach((item) => {
        storedata.value;
      });
      storedata.value = data;
      state.showStore = false;
    };
    //批量设置经销商
    const BatchSettingsdelar = () => {
      delardata.value.forEach((v) => {
        v["task_number"] = state.BatchSetdelar;
      });
    };
    //批量设置门店
    const BatchSettingsstore = () => {
      storedata.value.forEach((v) => {
        v["task_number"] = state.BatchSetstore;
      });
    };
    const delstore = (e) => {
      storedata.value.splice(e, 1);
    };
    //删除经销商
        const deldelar = (e) => {
      delardata.value.splice(e, 1);
    };
    
    const $router = inject("$router");
    // 下一步
    // const next = () => {
    //   $router.go(-1);
    // };
    const next = () => {
      // if (props.id) {
      //   update();
      // } else {
      create();
      // }
    };
    // 创建
    const create = async () => {
      form.value.range_data = [];
      console.log(delardata.value);
      if ($route.query.type == "edit") {
        if (form.value.range_type == 1) {
          delardata.value.map((v) => {
            form.value.range_data.push({
              range_id: v.dealer_id,
              task_number: v.task_number,
            });
          });
        } else {
          storedata.value.map((v) => {
            form.value.range_data.push({
              range_id: v.id || v.store_id,
              task_number: v.task_number,
            });
          });
        }
      } else {
        if (form.value.range_type == 1) {
          delardata.value.map((v) => {
            form.value.range_data.push({
              range_id: v.id || v.dealer_id,
              task_number: v.task_number,
            });
          });
        } else {
          storedata.value.map((v) => {
            form.value.range_data.push({
              range_id: v.id || v.store_id,
              task_number: v.task_number,
            });
          });
        }
      }

      console.log(form.value);
      let result = await twocontracting({
        ...form.value,
        id: props.id,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        $router.go(-1)
        emit("setpsOneDone", {
          ...form.value,
          id: result.data.id,
        });
      }
    };
    const provide = () => {
      emit("setpsTwoProvide", 1);
    };
    onMounted(() => {
      detail();
    });
    return {
      // storecolumns,
      // delarcolumns,
      form,
      ruleForm,
      storedata,
      delardata,
      // listLoading,
      list,
      detail,
      next,
      provide,
      ...toRefs(state),
      dealerSelect,
      storeSelect,
      BatchSettingsdelar,
      BatchSettingsstore,
      delstore,
      pageCurrentChange,
      pageSizeChange,
      dSearch,
      changedealer,
      deldelar
    };
  },
};
</script>